import { hasFeatureFlag } from '@/services';
import globalStore from '@/stores';
import store from '../store';
import { getPassiveAccSummary, showPassiveAccSummary } from '../api';
import { FrameType } from '..';

export const initPassiveAccAuth = async () => {
  if (!hasFeatureFlag('is_enable_accumulation_report')) {
    return false;
  }
  const res: any = await showPassiveAccSummary();
  const { agent_group } = res?.data || {};
  return !!agent_group;
};

export const initPassiveAccSummary = async () => {
  if (!hasFeatureFlag('is_enable_accumulation_report')) {
    return false;
  }
  const res: any = await getPassiveAccSummary();
  const { agent_group, frame_type_summaries = [] } = res?.data || {};
  const summaryInfoMap = frame_type_summaries.reduce((acc: any, curr: any) => {
    acc[curr.frame_type] = {
      ...curr,
      noticeDownload: curr.has_download_record === false,
    };
    return acc;
  }, {});
  const noticePassiveAccDownload = summaryInfoMap[FrameType.region]?.noticeDownload || summaryInfoMap[FrameType.ecommerce]?.noticeDownload;
  store.setSummaryInfoMap(summaryInfoMap);
  store.setAgentGroup(agent_group);
  globalStore.setNavBreathingLight('passiveAccumulation', noticePassiveAccDownload);
};
